function Booking() {
  return (
    <div>
      <h2>Book Your Stay</h2>
      <p>We’re currently working on launching online booking. In the meantime, please contact us to reserve your room:</p>
      
      <p><strong>Phone:</strong> (912) 275-5000</p>
      <p>
          <strong>Email: </strong> 
          <a className="email-link" href="mailto:welcomeinn1921@gmail.com">welcomeinn1921@gmail.com</a>
          <br />
          <strong> or </strong>
          <br />
          <strong>Book through our partners:</strong>
          <br />
          <a className="booking-platform1" href="https://www.booking.com/hotel/us/welcome-inn-st-marys.html">Booking</a>
          <br />
          <a className="booking-platform1" href="https://www.expedia.com/St-Marys-Hotels-Welcome-Inn.h115180409.Hotel-Information?chkin=2025-06-01&chkout=2025-06-02&x_pwa=1&rfrr=HSR&pwa_ts=1748447094024&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jb20vSG90ZWwtU2VhcmNo&useRewards=false&rm1=a2&regionId=55979&destination=St.+Marys%2C+Georgia%2C+United+States+of+America&destType=MARKET&latLong=30.747896%2C-81.57061&sort=PRICE_LOW_TO_HIGH&top_dp=75&top_cur=USD&userIntent=&selectedRoomType=326669791&selectedRatePlan=402215317&searchId=0d92ca48-ade7-4488-8f72-8ab15dc32cbd">Expedia</a>
          <br />
          <a className="booking-platform1" href="https://www.hotels.com/ho3686773088/welcome-inn/?chkin=2025-05-30&chkout=2025-05-31&x_pwa=1&rfrr=HSR&pwa_ts=1748448198810&referrerUrl=aHR0cHM6Ly93d3cuaG90ZWxzLmNvbS9Ib3RlbC1TZWFyY2g%3D&useRewards=false&rm1=a2&regionId=55979&destination=St.+Marys%2C+Georgia%2C+United+States+of+America&destType=MARKET&latLong=30.747896%2C-81.57061&sort=PRICE_LOW_TO_HIGH&top_dp=75&top_cur=USD&userIntent=&selectedRoomType=326669791&selectedRatePlan=402215317&expediaPropertyId=115180409&searchId=8c973c68-a75f-47e5-8066-277e6d4dc836">Hotels</a>
        </p>
    </div>
  );
}

export default Booking;
